module.exports = __webpack_public_path__ + "img/badge_refazi_situazione_att.0fca8246.jpg";